function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M116 16c-30.928 0-56 25.143-56 56.16v43.766c0 20.366 15.946 35.122 36 36.03v-14.318c-7.289-4.825-14.369-13.027-18.3-26.62-3.733 1.168-7.75-.854-9.132-4.685l-4.097-11.362c-1.437-3.987.523-8.424 4.38-9.91a7.188 7.188 0 014.673-.182c1.402 1.16 2.64 2.935 2.64 2.935s1.565-7.724 7.487-12.165c7.702-5.776 10.56-13.05 11.597-18.74 6.105 8.605 19.147 17.738 38.159 18.778 17.098.935 21.783 17.92 21.783 17.92s.225-6.972 3.074-9.037c1.569-.26 3.555-.166 4.886.347 3.856 1.486 5.816 5.923 4.379 9.91l-4.148 11.501c-1.158 3.212-5.168 5.152-8.311 5.008-3.667 13.215-11.264 21.418-19.07 26.299v14.321c20.054-.908 36-15.664 36-36.03V90.144c.361-6.339.39-12.34 0-17.968v-.017c0-10.545-2.898-20.41-7.939-28.84a41.58 41.58 0 00-.539-.883C153.628 26.56 136.044 16 116 16z",
  fill: "#FFAA6C"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M163.717 74.025a3.551 3.551 0 00-4.885-1.165l-13.831 8.501a3.551 3.551 0 004.885 1.166l13.831-8.502zM141 78.023a3.552 3.552 0 004.979.663l12.893-9.866a3.552 3.552 0 00-4.979-.662L141 78.023z",
  fill: "#72AEFF"
});

function SvgHair11(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 232,
    height: 232,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default __webpack_public_path__ + "static/media/hair-1-1.0e193d71.svg";
export { SvgHair11 as ReactComponent };